module.exports = {"development":{"admin_url":"http://localhost:1337","main_server":"http://localhost:8000","elastic_server":"https://es.growjo.com","api_credentials":"growjoApiUser:jk6!5Z9PubB.HvZ"},"production":{"admin_url":"https://admin.growjo.com","main_server":"https://growjo.com","elastic_server":"https://es.growjo.com","api_credentials":"growjoApiUser:jk6!5Z9PubB.HvZ"},"staging":{"admin_url":"https://admin.growjo.com","main_server":"https://staging.growjo.com","elastic_server":"https://es.growjo.com","api_credentials":"growjoApiUser:jk6!5Z9PubB.HvZ"}}


//////////////////
// WEBPACK FOOTER
// ./client/src/config.json
// module id = ./client/src/config.json
// module chunks = 0